import { CASES, questionById } from "./content";

export function readinessOf(data) {
  if (!data) return 0;
  const answered = data.answered || 0;
  const correct = data.correct || 0;
  const knowledge = answered > 0 ? correct / answered : 0;
  let appA = 0, appC = 0;
  Object.entries(data.qstats || {}).forEach(([id, st]) => {
    const q = questionById(id);
    if (q && (q.type === "case" || q.type === "spot")) { appA += st.attempts; appC += st.correct; }
  });
  const application = appA > 0 ? appC / appA : knowledge;
  const cases = CASES.length ? (data.cases?.length || 0) / CASES.length : 0;
  const seen = Object.values(data.flashcards || {});
  const retention = seen.length ? seen.reduce((s, f) => s + (f.box || 0), 0) / (seen.length * 5) : 0;
  const active = answered > 0 || seen.length > 0 || (data.cases?.length || 0) > 0;
  if (!active) return 0;
  return Math.round((0.3 * knowledge + 0.3 * application + 0.2 * cases + 0.2 * retention) * 100);
}
